import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import HeaderBar from '../../../components/HeaderBar/HeaderBar'
import DatasetsFilterBox from './DatasetsFilterBox'
import { useSelector } from 'react-redux'
import { DefaultState } from '../../../types'
import { useNavigate } from 'react-router-dom'

export const DynamicDatasetsPage: React.FC = () => {
  const navigate = useNavigate()
  const userData = useSelector((state: DefaultState) => state.session.data.user)
  const isAdmin = userData?.roles?.includes('admin') ? true : false

  if (!isAdmin) {
    navigate('/ui2/datasets/')
  }

  return (
    <Container fluid={true} className="wivi-container">
      <Row>
        <Col xs={12}>
          <HeaderBar
            origin="IPA"
            routes={[
              {
                title: 'Data Sets',
                url: '/ui2/datasets'
              },
              { title: 'Add' }
            ]}
            help={{ title: 'Data Sets / Add', text: '' }}
          />
        </Col>
      </Row>
      <Row>
        <DatasetsFilterBox />
      </Row>
    </Container>
  )
}

export default DynamicDatasetsPage
